import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Crystal_Wedding_Logo_Primary_v2.svg'


const _withScopeId = n => (_pushScopeId("data-v-f1e935ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Heartful Logo",
    class: "flex h-40 w-64 mx-auto"
  })
], -1))
const _hoisted_2 = { class: "font-bold text-xl w-full mb-4 text-center" }

import LoginForm from './components/LoginForm.vue'
	import WelcomeForm from './components/WelcomeForm.vue'

	import {
		useRoute,
		useRouter
	} from 'vue-router'

	import { 
		store as _userStore
	} from '@/store/user'

	import { 
		store as _jobStore
	} from '@/store/job'

	import {
		computed,
		onBeforeMount,
		ref
	} from 'vue'

	// language
	import {
		useI18n
	} from 'vue-i18n'

	
	const __default__ = { name: 'LoginMain' } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const {t} = useI18n()
	const router = useRouter()
	const userStore = _userStore()
	const jobStore = _jobStore()

	const currentRoute = computed(() => {
		return useRoute().name
	})

	const showWelcome = ref(true)

	onBeforeMount(async () => {
		try {
			// check for existing login & reroute
			if(jobStore.job.loggedIn) {
				// router.push({name: "Search"})
			}
		}
		catch(e) {
			console.log(e)
		}
	})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('welcome.welcomeHeader')), 1),
    (showWelcome.value)
      ? (_openBlock(), _createBlock(WelcomeForm, {
          key: 0,
          modelValue: showWelcome.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showWelcome).value = $event))
        }, null, 8, ["modelValue"]))
      : (_openBlock(), _createBlock(LoginForm, { key: 1 }))
  ], 64))
}
}

})